import { jsx as o, jsxs as i } from "react/jsx-runtime";
import n from "classnames";
import t from "./index.es750.js";
import { ICON_MAP as C } from "./index.es751.js";
import { uniqueId as A, noop as E } from "lodash/fp";
import { Provider as _, Viewport as x } from "@radix-ui/react-toast";
import { PRIMITIVE_TOAST_DEFAULT_TESTID as D, PrimitiveToast as w } from "./index.es752.js";
import { CtaButton as y } from "./index.es753.js";
import { BodyText as m } from "./index.es487.js";
const P = `${D}-toast`, S = ({
  open: l,
  title: c,
  icon: s,
  testId: d = P,
  subTitle: p,
  children: e,
  duration: T = 3e3,
  variant: a = "default",
  position: f = "bottom-right",
  isInStack: h,
  customPositioning: N,
  onOpenChange: I = E
}) => {
  const r = a === "inverted", u = n(t.actionsRoot, { [t.inverted]: r }), v = n(t.container, { [t.hasActions]: !!e });
  return /* @__PURE__ */ o(_, { swipeDirection: "right", children: /* @__PURE__ */ o(x, { className: t.toastViewport, label: A("Toasts - "), children: /* @__PURE__ */ i(
    w,
    {
      open: l,
      onOpenChange: I,
      testId: d,
      duration: T,
      isInStack: h,
      customPositioning: N,
      variant: a,
      position: f,
      children: [
        /* @__PURE__ */ i("div", { className: v, children: [
          s && !r && /* @__PURE__ */ o("span", { className: t.iconContainer, children: C[s] }),
          /* @__PURE__ */ i("div", { className: t.textContainer, children: [
            /* @__PURE__ */ o(m, { element: "p", color: r ? "white" : "primary", children: c }),
            /* @__PURE__ */ o(
              m,
              {
                isEllipsis: !0,
                color: r ? "disabled" : "gray",
                size: "small",
                children: p
              }
            )
          ] })
        ] }),
        e && /* @__PURE__ */ o("div", { className: u, children: e })
      ]
    }
  ) }) });
};
S.CtaButton = y;
export {
  P as TOAST_DEFAULT_TESTID,
  S as Toast
};
//# sourceMappingURL=index.es84.js.map
